import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Layout,
  FormLayout,
  Card,
  Loading,
  Text,
  TextField,
  Tabs,
  Badge,
  PageActions,
  InlineStack,
  Banner,
  Toast,
  Icon,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { accessSettings } from "../../Helpers";

const ShopifyDomain = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [item, setItem] = useState({
    shopifyDomain: "",
  });
  const handleChangeShopifyDomain = (newValue) => {
    setItem({ ...item, shopifyDomain: newValue });
    setDomainError("");
  };

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [domainError, setDomainError] = useState("");
  useEffect(() => {
    axios
      .get(`settings/shopify`)
      .then((result) => {
        setIsSaving(false);
        setItem({
          shopifyDomain: result?.data?.data?.shopify_domain
            ? result?.data?.data?.shopify_domain
            : "",
        });
      })
      .catch((err) => console.log(err));
  }, []);
  const handleSave = () => {
    setIsSaving(true);
    const form_data = new FormData();

    form_data.append("shopify_domain", item.shopifyDomain);
    form_data.append("_method", "PATCH");
    axios
      .post(`settings/shopify`, form_data)
      .then((res) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => {
        setDomainError(
          "The shopify domain must end with one of the following: .myshopify.com"
        );
        setIsSaving(false);
      });
  };
  return (
    accessSettings() && (
      <Page
        title="Shopify Domain"
        narrowWidth
        backAction={{
          onAction: () => navigate(`/admin/settings/integrations`),
        }}
      >
        <Card sectioned>
          {isSaving ? <Loading /> : null}
          <FormLayout>
            <TextField
              value={item.shopifyDomain}
              onChange={handleChangeShopifyDomain}
              label="Shopify Domain"
              placeholder="https://xxx.myshopify.com"
              error={domainError}
            />
          </FormLayout>
        </Card>
        <PageActions
          primaryAction={{
            content: "Save",
            onClick: handleSave,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
      </Page>
    )
  );
};

export default ShopifyDomain;
